// extracted by mini-css-extract-plugin
module.exports = {"ReceiveButton":"ReceiveButton_ReceiveButton__8TjE0","no_active_modal":"ReceiveButton_no_active_modal__MBH1g"};